import { Component, OnInit, ViewChild, ElementRef, ViewChildren, QueryList, OnDestroy, Input, SimpleChanges, OnChanges } from '@angular/core';
import { NgbDropdownConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { cDataService } from 'src/app/services/data.service';
import {SortableHeaderMediaMoksDirective, SortEvent} from '../sortable-media-monk.directive';
import { cSessionService } from 'src/app/services/session.service';
import { DatePipe } from '@angular/common';
import { JsonUtilsService } from 'src/app/services/json-utils.service';
@Component({
  selector: 'app-class-table',
  templateUrl: './class-table.component.html',
  styleUrls: ['./class-table.component.scss']
})
export class ClassTableComponent implements OnInit,OnDestroy,OnChanges {

  @Input() selectedClass : any;
  @Input() SelectedType : any;
  @Input() editingOption : boolean;
  @ViewChild('scrollContainer', { static: false }) scrollContainerRef: ElementRef;
  showSidebar = false;
  lDataTablesNames : any = [];
  sQueryString : string = "";
  sTableName : string ="";
  newArray : any = [];
  editing = {};
  editing1 = {};
  editingForModel = {};
  editingForAutoSuggestion = {};
  oSelectedTableDetails : any;
  lMenuConfigurationFooter : any;
  bResponseAlert : boolean = false;
  resMessage: { message: any, responseType:  any, color: any};
  loading = false;
  page = {size: 0,totalElements: 0,totalPages: 0, pageNumber: 0};
  visible:boolean=false
  @ViewChild('myInput') myinput:ElementRef;
  lTableAttributes : any = [];
  lTableRecords : any = [];
  oSelectedRecord : any;
  lsSelectedTableFromLocalStorage : any;
  oSchemaName : any;
  oPrimaryKeyGenerator : any;
  bEnablePrimaryKeyEditing : boolean = false;
  oSortingQuery = "";
  lColumnList : any = [];
  results :any[]=[];
  bLoading : boolean = false;
  @ViewChildren(SortableHeaderMediaMoksDirective) headers: QueryList<SortableHeaderMediaMoksDirective>;
  nCurrentPage = 1;
  lTotalElements : any = 0;
  sSelectedRow: any = '';
  nSelectedRowId: any = '';
  oCopyRecord : any = '';
  searchArray : any = [];
  SearchResults : any[] = [];
  sCellNameForDistinctValues : string = "";
  lOriginalRows :any []=[];
  nPreviousPage : number = 1;
  columnDirection : string = "";
  bSelectMode : boolean =false;
  lSelectedRecordsList = [];
  oSelectedRow={};
  sComponentToggle: any='3';
  bDataMangerEditableTable : boolean = false;
  bDisplayTableList: boolean = true;
  toggleListView: string ='toggle-view-on';
  lHiddenModalEditRows : any = [];
  bToggleOn : boolean = false;
  bAddNewTable : boolean = false;
  sSaveFunctionName : string = "";
  nInterval: any;
  bDeleteTableAccess: boolean=false;
  nDataTableSize : number = 80;
  lModalEditRows: any;
  lCustomizingTableColumns : any = [];
  nIncomingRwoIndexForModal : number;
  bModelUpdateButton : boolean = false;
  editMode:boolean=false
  createdHtml: any=undefined;

  constructor(private modalService: NgbModal , config: NgbDropdownConfig,private oDataService : cDataService ,private oSessionService: cSessionService,private dDatepipe : DatePipe,private jsonUtil: JsonUtilsService)
   { 
    config.autoClose = false;
    this.page.pageNumber = 0;
    this.page.size = this.nDataTableSize;
  }
  ngOnInit() 
  {
    // this.DataTablesComponent_SelectTable(this.selectedClass,this.SelectedType)
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedClass'] && this.selectedClass) {
      this.DataTablesComponent_SelectTable(this.selectedClass,this.SelectedType)
    }
  }
  DataTableComponent_DismissModal(){
    this.modalService.dismissAll();
  }
  DataTableComponent_ToggleSidebar() {
    this.showSidebar = !this.showSidebar;
  }
  DataTablesComponent_ShowAlert(sIncomingMessage,sIncomingType,sIncommingColor)
  {
    this.bResponseAlert = true 
    this.resMessage = 
    {
      message: sIncomingMessage,
      responseType : sIncomingType,
      color :  sIncommingColor
    };
    setTimeout(() => {this.bResponseAlert = false }, 3000);
  }

  DataTablesComponent_DismissAlert()
  {
    this.bResponseAlert=false;
  }
  DataTablesComponent_SelectTable(oIncommingTableDetails : any,sIncomingSelectType)
  {
    // console.log("Class Details are ==>",oIncommingTableDetails)
    if(sIncomingSelectType == 'internal')
    {
      localStorage.removeItem('lsTableAttributes');
      localStorage.removeItem('lSortingOrder');
    }
    this.loading=true;
    this.lTableRecords = [];
    this.newArray = [];
    this.page.totalElements = 0;
    this.sQueryString = "";
    this.sSelectedRow='';
    this.oCopyRecord="";
    this.lTotalElements = 0;
    this.nCurrentPage = 1;
    this.bDataMangerEditableTable = oIncommingTableDetails?.dataManagerEditable;
    this.oSelectedRecord = oIncommingTableDetails;
    this.sTableName = oIncommingTableDetails?.description?oIncommingTableDetails.description:oIncommingTableDetails?.name;
    if(oIncommingTableDetails)
    {
      this.DataTablesComponent_GetTableAttributes(oIncommingTableDetails);
      this.oSessionService.cSessionService_SetSelectedTableName(oIncommingTableDetails);
    }
    if (this.scrollContainerRef && this.scrollContainerRef.nativeElement) {
      this.scrollContainerRef.nativeElement.scrollTop = 0;
      this.scrollContainerRef.nativeElement.scrollLeft = 0;
      }
  }
  // Get Distinct Values For Auto Suggestion
  DataTablesCOmponent_GetDistinctValuesForAutoSuggestion(oIncommingTableDetails)
  {
    let dsName:string;
    let fileName : string = oIncommingTableDetails.fileName;
    
    if(fileName.split('/')[2] == null)
    {
       dsName = fileName.split('/')[0];
    }
    else
    {
      dsName = "";
      let beta = fileName.split('/')
      for(let i=2;i < beta.length-1; i++)
      {
        dsName = dsName + "/" + beta[i];
      }
      dsName = dsName.substring(1);
    }
    let name = oIncommingTableDetails.name;
    this.SearchResults = [];
    this.oDataService.DataService_GetDistinctValuesForAutoSuggestion(dsName,name,this.oSchemaName,this.oSelectedTableDetails.appName).subscribe({next : result => {
      if(result.status == 'failed')
      {
        this.DataTablesComponent_ShowAlert(result.message,"danger","danger");
        console.log("DataTablesCOmponent_GetDistinctValuesForAutoSuggestion : Error Response =>",result);
      }
      else
      {
        this.SearchResults = result;
        // console.log("DataTablesCOmponent_GetDistinctValuesForAutoSuggestion : Success Response =>",this.SearchResults);
      }
    },
    error : (error) =>
    {
      console.log("error ====>>>>>",error)
      this.DataTablesComponent_ShowAlert("Internal server error, please try again later.","danger","danger")
    }});
  }
  // Get Table Attributes
  DataTablesComponent_GetTableAttributes(oIncommingTableDetails : any)
  {
    try
    {
      this.loading=true;
      this.lTableRecords=[];
      this.DataTablesComponent_Resetheadersorting();
      let body = 
      {
        name : oIncommingTableDetails.name,
        fileName : oIncommingTableDetails.fileName
      }
      this.oDataService.DataService_GetDataTableAttributes(body).subscribe({next : (result : any) => 
      {
        if(result.status == 'failed')
        {
          console.log("DataTablesComponent_GetTableAttributes : Error Response ==> ",result);
          this.DataTablesComponent_ShowAlert("Internal server error, please try again later.","danger","danger")
        }
        else
        {
          // console.log("DataTablesComponent_GetTableAttributes : Success Response ==> ",result);
          this.oSelectedTableDetails = result;
          this.oDataService.bTableAttributes.next(result);
          let lAttributes = result?.content?.attributes;
          this.oPrimaryKeyGenerator = result?.content?.primaryKeyGenerator;
          // console.log("Incomig Primary Key Generator ==>>>",this.oPrimaryKeyGenerator);
          if(result?.content?.schemaName)
          {
            this.oSchemaName = result.content.schemaName;
          }
          this.lTableAttributes = [];
          this.lColumnList = [];
          this.lCustomizingTableColumns = [];
          this.newArray = [];
          this.sSelectedRow = "";
          this.sSaveFunctionName = result.content.uiProps?.saveFunctionName??'';
          for (let nAttributeIndex = 0; nAttributeIndex < lAttributes?.length; nAttributeIndex++) 
          {
            const oAttribute = lAttributes[nAttributeIndex];
            let bPrimaryKey : boolean = oAttribute?.primaryKey?true:false;
            this.lTableAttributes.push({prop : oAttribute.name, value : '',inputType : oAttribute?.uiProps?.type,ruleId : oAttribute?.uiProps?.ruleId??"",acPermitsNewValue : oAttribute?.uiProps?.acPermitsNewValue == undefined ? true : oAttribute?.uiProps?.acPermitsNewValue,
            autoComplete : oAttribute?.uiProps?.autoComplete ? oAttribute?.uiProps?.autoComplete : false,inputPattern : oAttribute?.uiProps?.pattern,patternMessage : oAttribute?.uiProps?.message ? oAttribute?.uiProps?.message : '',name : oAttribute.name, primary : bPrimaryKey,
            nameInDS : oAttribute?.nameInDS?oAttribute?.nameInDS:oAttribute?.name, editable : oAttribute?.editable ? oAttribute.editable : false , dataManagerHidden : oAttribute.dataManagerHidden ? true : false,direction:"",searchString:"",valueLength : oAttribute.length?oAttribute.length.toString():'',
            columnShow : true,systemAttr:oAttribute?.systemAttr ? oAttribute.systemAttr : false,naming:oAttribute?.naming ? oAttribute.naming : false,listHidden:oAttribute?.listHidden ? oAttribute.listHidden : false});
            this.lColumnList.push({prop : oAttribute.name,value : (oAttribute?.nameInDS?oAttribute?.nameInDS:oAttribute?.name)??''});
          }
          if(this.lTableAttributes[0].name=='id' && this.lTableAttributes[0].naming)this.lTableAttributes[0].naming=false
          this.lTableAttributes=   this.relocateNamingTrueToIndexOne(this.lTableAttributes)
          this.oSessionService.cSessionService_SetAttributesList(this.lTableAttributes);

          // console.log("Table Attributes are", this.lTableAttributes,this.lColumnList,this.lTableRecords)
     
          if(this.lTableAttributes.length > 0)
          {
            this.lTableAttributes.forEach(element => {
              if(element.dataManagerHidden == false)
              {
                this.lCustomizingTableColumns.push({prop : element.prop,columnShow : true})
              }
            })
          }
          if(this.oSelectedTableDetails)
          {
            let sortingBody = this.oSessionService.cSessionService_GetSortingData();
            if (Object.keys(sortingBody).length > 0) 
            {
              let lsAtrributes = this.oSessionService.cSessionService_GetAttributesList();
              if(Object.keys(lsAtrributes).length > 0)
              {
                this.lTableAttributes = this.oSessionService.cSessionService_GetAttributesList();
                this.lCustomizingTableColumns = [];
                this.lTableAttributes.forEach(element => {
                  if(element.dataManagerHidden == false)
                  {
                    this.lCustomizingTableColumns.push({prop : element.prop,columnShow : element.columnShow})
                  }
                })
              }
              this.DataTablesComponent_GetTableRecords(this.nDataTableSize,1,sortingBody?.where??"",this.oSelectedRecord,sortingBody?.orderBy??"asc")
            } 
            else 
            {
              this.DataTablesComponent_GetTableRecords(this.nDataTableSize,1,this.sQueryString,this.oSelectedRecord,'asc')
            }
  
            this.DataTablesCOmponent_GetDistinctValuesForAutoSuggestion(oIncommingTableDetails)
          }
        }
   
        
      },
      error:(error) =>
      {
        console.log("error ====>>>>>",error)
        this.DataTablesComponent_ShowAlert("Internal server error, please try again later.","danger","danger")
      }});
    }
    catch(catchError)
    {
      console.log("DataTablesComponent_GetReportsAttributes : Error ==> ",catchError);
    }
  }
  relocateNamingTrueToIndexOne(arr: any[]): any[] {
    const indexToMoveTo = 1;
  
    const index = arr.findIndex(attr =>
      attr.naming === true &&
      attr.systemAttr !== true &&
      attr.listHidden !== true
    );
  
    if (index > -1 && index !== indexToMoveTo) {
      const element = arr[index];
      const newArr = arr.slice(); // create a copy
      newArr.splice(index, 1);    // remove from old index
      newArr.splice(indexToMoveTo, 0, element); // insert at new index
      return newArr;
    }
  
    return arr;
  }
  
  // Get Table Records
  DataTablesComponent_GetTableRecords(nIncommingSize : number, nIncommingStart : number, sIncommingWhereClause : string, sIncommingTable : any,nIncomingOrder : any)
  {
    try
     {
      this.loading = true;
      this.bLoading = true;
      let dsName:string;
      let fileName : string = sIncommingTable.fileName;
      if(fileName.split('/')[2] == null)
      {
         dsName = fileName.split('/')[0];
      }
      else
      {
        dsName = "";
        let beta = fileName.split('/')
        for(let i=2;i < beta.length-1; i++)
        {
          dsName = dsName + "/" + beta[i];
        }
        dsName = dsName.substring(1);
      }
      let name = sIncommingTable.name;
      let oDataOrder = "";
      let columnName = this.lTableAttributes.findIndex(element => {return element.primary})
      if(dsName.includes('postgres') || dsName.includes('Source_MasterData') || dsName.includes('Source_MasterData_Dev'))
      {
        for(let nIndex = 0;nIndex < this.lColumnList.length; nIndex++)
        {
          if(this.lColumnList[nIndex]?.prop == this.lTableAttributes[columnName]?.prop)
          {
            let newValue = this.lColumnList[nIndex].value;
            if(nIncomingOrder == 'asc' ||nIncomingOrder =='desc')
            {
              oDataOrder = "\"" + newValue + "\" " + nIncomingOrder;
            }
            else
            {
              oDataOrder = nIncomingOrder;
            }
          }
        }
      }
      else
      {
        if(nIncomingOrder == 'asc' ||nIncomingOrder =='desc')
        {
          oDataOrder = "t1." + this.lTableAttributes[columnName].prop + " " + nIncomingOrder;
        }
        else
        {
          oDataOrder = nIncomingOrder;
        }
      }
       let body = 
        {
          "size": nIncommingSize,
          "start": nIncommingStart,
          "where": sIncommingWhereClause,
          "usingRowLimits": true,
          "orderBy": oDataOrder,
        }
        if(body.where==="")
        {
          delete body.where;
        }
        this.oDataService.DataService_GetTableRecords(body,dsName,name,this.oSchemaName,this.oSelectedTableDetails.appName).subscribe({next:(result : any) => 
        {
        //  console.log("DataTablesComponent_GetTableRecords : Response ==> ",result);
         if(result.status==='failed')
         {
          this.lTableRecords = [];
          this.bLoading = true;
          this. lTotalElements = 0;
          this.DataTablesComponent_ShowAlert("Internal server error, please try again later.","danger","danger")
         }
         else
         {
           this.lTableRecords = [];
           this.lTableRecords = result.items;
           if(this.lTableRecords)
           {
            this.lTableRecords.forEach(record=>{
              for (const key in record) 
              {
                let attribIndex = this.lTableAttributes.findIndex(attribute=>{return attribute.name===key});
                if( attribIndex!=-1)
                {
                  if (this.lTableAttributes[attribIndex].ruleId=="percentageRule") 
                  {
                    record[key]=Math.round(JSON.parse(`${record[key]}`) * 100) + '%';
                  }
                  else if (this.lTableAttributes[attribIndex].ruleId=="currencyRule")
                  {
                    record[key] = '$' + record[key].toFixed(2)
                  }
                }
              }
            })
            for(let nIndex = 0; nIndex < this.lTableRecords.length;nIndex++)
            {
              for(const [key,value] of Object.entries(this.lTableRecords[nIndex]))
              {
                if(`${key}`.includes('_Date'))
                {
                  let dateString = `${value}`
                  this.lTableRecords[nIndex][key] = this.dDatepipe.transform(dateString, 'MM/dd/yyyy');
                }
              }
            }
            this.bLoading = false;
            // Below If condition is for Hiding the Records From Monk_Map Table where record?.Level_2_Client == 'Google' && record?.End_Date == '12/31/2022'
            if(name == 'Monk_Map')
            {
              this.lTableRecords = this.lTableRecords.filter(record => record?.Level_2_Client !== "Google" || record?.End_Date !== "12/31/2022")
            }
            }
            this.lTotalElements = result.totalItems;
            setTimeout(() => {this.loading = false}, 1000);
         }
         this.lOriginalRows = JSON.parse(JSON.stringify(this.lTableRecords));
         
       },
       error:(error) =>
       {
         console.log("error ====>>>>>",error)
         this.bLoading = false;
          this.DataTablesComponent_ShowAlert("Internal server error, please try again later.","danger","danger")
       }});
     }
     catch(catchError)
     {
       console.error("DataTablesComponent_GetTableRecords : Error ==> ",catchError);
     }
  }

  // mobileSidebar() 
  // {
  //   this.showSidebar = !this.showSidebar;
  // }
  DataTablesComponent_GetValuesFromInput(event,nInComingIndex)
  {
    let filteredValue = event.target.value;
    if (filteredValue != "" && filteredValue != undefined) 
    {
      if(filteredValue.includes('*'))
      {
        if(filteredValue.startsWith('*'))
        {
          filteredValue = filteredValue.replace("*",'')
          this.lTableAttributes[nInComingIndex].ruleId == "percentageRule" && !filteredValue.includes('.')? filteredValue = (filteredValue/100): "";
          filteredValue = '%'+filteredValue;
        }
        if(filteredValue.endsWith('*'))
        {
          filteredValue = filteredValue.replace("*",'')
          this.lTableAttributes[nInComingIndex].ruleId == "percentageRule" && !filteredValue.includes('.')? filteredValue = (filteredValue/100): "";
          filteredValue = filteredValue+'%';
        }
      }
      else
      {
        if (filteredValue.includes('%')) 
        {
          filteredValue = filteredValue.replace("%",'')
          this.lTableAttributes[nInComingIndex].ruleId == "percentageRule" && !filteredValue.includes(".")? filteredValue = (filteredValue/100): "";
          filteredValue = '%' + filteredValue;
        } 
        else 
        {
          this.lTableAttributes[nInComingIndex].ruleId == "percentageRule" && !filteredValue.includes(".")? filteredValue = (filteredValue/100): "";
        }
      }
    } 
    else 
    {
      this.lTableAttributes[nInComingIndex].value = "";
    }
    this.lTableAttributes[nInComingIndex].value = filteredValue+"";
  }
  DataTablesComponent_SetValuesForSearchingReocrds(nInComingCellValue,nInComingIndex)
  {
    this.lTableAttributes[nInComingIndex].value = nInComingCellValue;
    this.DataTablesComponent_FilterDataFromTableUsingQuery();
  }
  DataTablesComponent_ClickOnInputForFilteredRecords(nIncomingCellValue)
  {
    this.searchArray = [];
    this.results = [];
    let num = 1
    for(const [key,value] of Object.entries(this.SearchResults))
    {
      if(`${key}` == nIncomingCellValue)
      {
        let distinctVlaueArray : any = [];
        distinctVlaueArray = [value];
        this.sCellNameForDistinctValues = nIncomingCellValue;
        if(distinctVlaueArray[0])
        {
          distinctVlaueArray[0].forEach(element => {if(element!="")this.searchArray.push(element)});
        }
      }
    }
    this.results = this.searchArray;
  }
  DataTablesComponent_ClearTheCellNameForClosingDropDownofAutoSuggestion()
  {
    setTimeout(() => {this.sCellNameForDistinctValues = "";},100);
  }
  DataTablesComponent_FilterDataFromTablePressingEnter(keycode,event,nInComingIndex)
  {
    if (this.newArray.length>0) 
    {
      this.DataTableComponent_ShowErrorUnsavedRecords('Searching');
    }
    else 
    {
      let filteredValue = event.target.value;
      if(keycode == 13 && filteredValue != "" && filteredValue !=null && filteredValue != undefined)
      {
        setTimeout(() => {
          this.DataTablesComponent_FilterDataFromTableUsingQuery();
          this.sCellNameForDistinctValues = "";
        }, 500);
      }
      else if(keycode == 13 && (filteredValue == "" || filteredValue ==null && filteredValue == undefined))
      {
        this.lTableAttributes[nInComingIndex].value = "";
        this.DataTablesComponent_FilterDataFromTableUsingQuery();
      }
    }
  }
  DataTablesComponent_FilterDataFromTableUsingQuery()
  {
    this.sQueryString = "";
    this.lTableAttributes;
    for(let nIndex=0;nIndex<this.lTableAttributes.length;nIndex++)
    {
      if(this.lTableAttributes[nIndex].value != "")
      {
        let bPercentageSign = (this.lTableAttributes[nIndex].value?.startsWith('%') || this.lTableAttributes[nIndex].value?.endsWith('%'))?true:false;
        let x = this.lTableAttributes[nIndex].nameInDS?this.lTableAttributes[nIndex].nameInDS:this.lTableAttributes[nIndex].name;
        if(this.oSelectedTableDetails.content?.schemaName)
        {
          if(x !== x.toLowerCase())
          {
            x = "\"" + x + "\""; 
          }
          if(this.sQueryString == "")
          {
            this.sQueryString = bPercentageSign ? x + " like '" + this.lTableAttributes[nIndex].value+"'" : x + "='" + this.lTableAttributes[nIndex].value+"'";
          }
          else
          {
            this.sQueryString =  bPercentageSign ? this.sQueryString + " and " + x + " like '" + this.lTableAttributes[nIndex].value+"'" :this.sQueryString + " and " + x + "='" + this.lTableAttributes[nIndex].value+"'";
          }
        }
        else
        {
          if(this.sQueryString == "")
          {
            this.sQueryString = bPercentageSign? this.lTableAttributes[nIndex].name + " like '" + this.lTableAttributes[nIndex].value+"'" :this.lTableAttributes[nIndex].name + "='" + this.lTableAttributes[nIndex].value+"'";
          }
          else
          {
            this.sQueryString = bPercentageSign?this.sQueryString + " and " + this.lTableAttributes[nIndex].name+" like '"+this.lTableAttributes[nIndex].value+"'" : this.sQueryString + " and " + this.lTableAttributes[nIndex].name+"='"+this.lTableAttributes[nIndex].value+"'";
          }
        }
      }
    }
    let previousBody = this.oSessionService.cSessionService_GetSortingData();
    previousBody = 
    {
      ...previousBody,
      where:this.sQueryString
    }
    this.oSessionService.cSessionService_SetSortingData(previousBody);
    this.oSessionService.cSessionService_SetAttributesList(this.lTableAttributes);
    let oDirection = this.oSessionService.cSessionService_GetSortingData();
    if(oDirection?.orderBy != '')
    {
      this.DataTablesComponent_GetTableRecords(this.nDataTableSize,1,this.sQueryString,this.oSelectedRecord,oDirection.orderBy);
    }
    else
    {
      this.DataTablesComponent_GetTableRecords(this.nDataTableSize,1,this.sQueryString,this.oSelectedRecord,'asc');
    }
  }
  DataTablesComponent_AddNewRow() 
  {
    //Copy the data
    let oRecord : any = {};
    for (let nRecordToPushIndex = 0; nRecordToPushIndex < this.lTableAttributes.length; nRecordToPushIndex++) 
    {
      if(this.lTableAttributes[nRecordToPushIndex].prop != 'id' && this.lTableAttributes[nRecordToPushIndex].prop != 'ID')
      {
        const sProp = this.lTableAttributes[nRecordToPushIndex].prop;
        Object.defineProperty(oRecord,sProp,{value : '',writable: true,enumerable: true,configurable: true});
        Object.defineProperty(oRecord,'_new_',{value : true,writable: false,enumerable: false,configurable: false});
      }
    }
    this.DataTablesComponent_AddorUpdateRecords(oRecord);
  }
  DataTablesComponent_AddNewDuplicateRow()
  {
    //Copy the data
    let oRecord : any = {};
    if(this.sSelectedRow != "")
    {
      for (let nRecordToPushIndex = 0; nRecordToPushIndex < this.lTableAttributes.length; nRecordToPushIndex++) 
      {
        const sProp = this.lTableAttributes[nRecordToPushIndex].prop;
        const bPrimary = this.lTableAttributes[nRecordToPushIndex].primary;
        for(const [key,value] of Object.entries(this.oCopyRecord))
        {
          if(`${key}` == sProp && bPrimary == false)
          {
            Object.defineProperty(oRecord,sProp,{value : (`${value}`),writable: true,enumerable: true,configurable: true});
          }
        }
        Object.defineProperty(oRecord,'_new_',{value : true,writable: false,enumerable: false,configurable: false});
      }
      this.DataTablesComponent_AddorUpdateRecords(oRecord);
    }
  }
  DataTablesComponent_AddorUpdateRecords(oRecord)
  {
    this.lTableRecords.unshift(oRecord);
    this.newArray.push(this.lTableRecords[0])
    this.lOriginalRows.unshift(JSON.parse(JSON.stringify(oRecord)));
    this.lTableRecords = this.lTableRecords.slice();
    this.lOriginalRows = this.lOriginalRows.slice();
    this.page.totalElements = this.lTableRecords.length;
  }
  DataTablesComponent_UpdateSelectedCellValue(event, cell, rowIndex,nIncomingInputType) 
  {
    switch (cell) {
      case 'date_TimeSent':
        if(event.target.value != '') this.lTableRecords[rowIndex][cell] = this.dDatepipe.transform(event.target.value, 'MM/dd/yyyy hh:mm');
        break;
      case 'orderDate':
        if(event.target.value != '')  this.lTableRecords[rowIndex][cell] = this.dDatepipe.transform(event.target.value, 'MM/dd/yyyy');
        break;
      case 'deliveryDate':
        if(event.target.value != '')  this.lTableRecords[rowIndex][cell] = 'DATE ' + this.dDatepipe.transform(event.target.value,'MM-dd-yyyy');
        break;
      default:
        this.lTableRecords[rowIndex][cell] = event.target.value;
        break;
      }
      if(nIncomingInputType == 'date' && cell != 'date_TimeSent' && cell != 'orderDate' && cell != 'deliveryDate')
      {
        if(event.target.value != '')
        {
          let date = new Date(event.target.value).getFullYear();
          if(date > 9999)
          {
            let value = '12-31-9999'
            this.lTableRecords[rowIndex][cell]=this.dDatepipe.transform(value, 'MM/dd/yyyy')
          }
          else if (date<1970)
          {
            this.lTableRecords[rowIndex][cell]=this.dDatepipe.transform('1-1-1970', 'MM/dd/yyyy')
          }
          else
          {
            this.lTableRecords[rowIndex][cell] = this.dDatepipe.transform(event.target.value, 'MM/dd/yyyy')
          }
        }
      }
      this.DataTablesComponent_ImplementedRuleID(event,rowIndex,cell,'onFocusOut')
      setTimeout(() => {this.editing[rowIndex + '-' + cell] = false;}, 500);
      for (const key in this.lTableRecords[rowIndex]) 
      {
        if (this.lOriginalRows[rowIndex][key]!= this.lTableRecords[rowIndex][key])
        {
          let index = this.newArray.indexOf(this.lTableRecords[rowIndex])
          if(index == -1)
          {
            if(this.lTableRecords[rowIndex].hasOwnProperty('_new_')) 
            {
              const isEmpty = Object.values(this.lTableRecords[rowIndex]).every(x => x === null || x === '');
              if (!isEmpty) 
              {
                this.newArray.push(this.lTableRecords[rowIndex]);
              } 
            } 
            else
            {
              this.newArray.push(this.lTableRecords[rowIndex]);
            }
          }
          else
          {
            this.newArray.splice(index,1,this.lTableRecords[rowIndex]);
          }
          break;
        }
        else
        {
          let index = this.newArray.indexOf(this.lTableRecords[rowIndex])
          if(index!= -1)
          {
            this.newArray.splice(index,1);
          }
        }
      }
  }
  DataTablesComponent_UpdateSelectedCellValueFor(nIncomingCellValue, cell, rowIndex,nIncomingPattern,nIncomingPatternMessage) 
  {
    var re = new RegExp(nIncomingPattern);
    if(re.test(nIncomingCellValue))
    {
      delete this.editing1[rowIndex + '-' + cell];
      this.DataTableComponent_Resetalert();
    }
    else
    {
      this.editing1[rowIndex + '-' + cell] = true;
      let sResMessage  = "";
        if(nIncomingPatternMessage)
        {
          sResMessage = nIncomingPatternMessage;
        }
        else
        {
          sResMessage = "Column "+ cell +" has invalid value.";
        }
      this.DataTablesComponent_ShowAlert(sResMessage,"danger","danger")
    }
    this.lTableRecords[rowIndex][cell] = nIncomingCellValue;
    for (const key in this.lTableRecords[rowIndex])
    {
      if (this.lOriginalRows[rowIndex][key]!= this.lTableRecords[rowIndex][key])
      {
        let index = this.newArray.indexOf(this.lTableRecords[rowIndex])
        if(index == -1)
        {
          if(this.lTableRecords[rowIndex].hasOwnProperty('_new_')) 
          {
            const isEmpty = Object.values(this.lTableRecords[rowIndex]).every(x => x === null || x === '');
            if (!isEmpty) 
            {
              this.newArray.push(this.lTableRecords[rowIndex]);
            } 
          } 
          else
          {
            this.newArray.push(this.lTableRecords[rowIndex]);
          }
        }
        else
        {
          this.newArray.splice(index,1,this.lTableRecords[rowIndex]);
        }
        break;
      }
      else
      {
        let index = this.newArray.indexOf(this.lTableRecords[rowIndex])
        if(index!= -1)
        {
          this.newArray.splice(index,1);
        }
      }
    }
  }
  DataTablesComponent_ImplementedRuleID(event,rowIndex,cell,click)
  {
    for(let i = 0;i<this.lTableAttributes.length;i++)
    {
      if(this.lTableAttributes[i].ruleId == 'percentageRule')
      {
        if(this.lTableAttributes[i].name == cell)
        {
          if(click == 'click')
          {
            if(event.target.value.includes('%')) event.target.value = event.target.value.slice(0,-1)
            this.lTableRecords[rowIndex][cell] = event.target.value;
          }
          if(click == 'onFocusOut')
          {
            if(event.target.value != '')this.lTableRecords[rowIndex][cell] = event.target.value + '%';
          }
        }
      }
      else if(this.lTableAttributes[i].ruleId == 'currencyRule')
      {
        if(this.lTableAttributes[i].name == cell)
        {
          if(click == 'click')
          {
            if(event.target.value.includes('$')) event.target.value = event.target.value.slice(1)
            this.lTableRecords[rowIndex][cell] = event.target.value;
          }
          if(click == 'onFocusOut')
          {
            if(event.target.value != '')this.lTableRecords[rowIndex][cell] = '$' + event.target.value;
          }
        }
      }
    }
  }
  DataTablesComponent_EditCell(keycode,cell, rowIndex,nIncomingrow , oIncommingObject,nInocmingPattern,event,nIncomingPatternMessage,nIncomingInputType,editable) 
  {
    if (this.bSelectMode) 
    {
      let nIndex = this.lSelectedRecordsList.findIndex(record=>{return record == oIncommingObject})
      if (nIndex!=-1) 
      {
        this.oSelectedRow[rowIndex]=false;
        this.lSelectedRecordsList.splice(nIndex,1);
      } 
      else 
      {
        this.oSelectedRow[rowIndex]=true;
        this.lSelectedRecordsList.push(oIncommingObject)
      }
    } 
    else 
    {
      this.DataTablesComponent_ImplementedRuleID(event,rowIndex,cell,'click')
      this.sCellNameForDistinctValues = "";
      this.results = [];
      this.searchArray = [];
      for(const [key,value] of Object.entries(this.SearchResults))
      {
        if(`${key}` == cell)
        {
          let distinctVlaueArray : any = [];
          distinctVlaueArray = [value];
          if(distinctVlaueArray[0])
          {
            distinctVlaueArray[0].forEach(element => {if(element!="")this.searchArray.push(element)});
          }
        }
      }
      this.results = this.searchArray;
      if(editable)this.DataTableComponent_OnKeyPress(event,nInocmingPattern,cell,nIncomingPatternMessage,rowIndex);
      this.sSelectedRow = oIncommingObject;
      this.oCopyRecord = oIncommingObject;
      let name = "";
      for (let nRecordToPushIndex = 0; nRecordToPushIndex < this.lTableAttributes.length; nRecordToPushIndex++) 
      {
        if(this.lTableAttributes[nRecordToPushIndex].primary == true)
        {
          name = this.lTableAttributes[nRecordToPushIndex].name;
        }
      }
      for(const [key,value] of Object.entries(this.oCopyRecord))
      {
        if(`${key}` === name)
        {
          this.nSelectedRowId = (`${value}`)
        }
      }
      this.bEnablePrimaryKeyEditing = false;
      if(this.lTableRecords[rowIndex].hasOwnProperty("_new_") && (cell != 'id' || cell !='ID') )
      {
        this.bEnablePrimaryKeyEditing = true;
      }
      if(!nIncomingrow.primary || keycode == 9 || (cell != 'id' || cell != 'ID'))
      {
        setTimeout(()=>{
            if(editable == true || this.lTableRecords[rowIndex].hasOwnProperty("_new_"))
            {
              this.myinput?.nativeElement.focus();
            }
            if(nIncomingInputType == 'date' && cell != 'date_TimeSent' && cell != 'orderDate' && cell != 'deliveryDate')
            {
              this.myinput.nativeElement.value = this.dDatepipe.transform(this.lTableRecords[rowIndex][cell],'yyyy-MM-dd');
            }
        })
        if(editable == true || (this.lTableRecords[rowIndex].hasOwnProperty("_new_") && (cell != 'id' || cell !='ID')))
        {
          this.editing={};
          this.editing[rowIndex + '-' + cell] = true;
          this.visible=true;
        }
      }
    }
  } 
  
  DataTablesComponent_SaveEditReocrds()
  {
    if (JSON.stringify(this.editing1) !== '{}') 
    {
      this.DataTablesComponent_ShowAlert("Please address the highlighted issues before saving.","danger","danger");
    } 
    else
    {
    for(let i = 0;i<this.lTableAttributes.length;i++)
    {
      if(this.lTableAttributes[i].ruleId == 'percentageRule' || this.lTableAttributes[i].ruleId == 'currencyRule')
      {
        for(let nIndex = 0; nIndex < this.newArray.length;nIndex++)
        {
          for(const [key,value] of Object.entries(this.newArray[nIndex]))
          {
            if(`${key}` == this.lTableAttributes[i].name)
            {
              let cellValue  : any = value;
              if(cellValue.includes('$')) cellValue = parseFloat(cellValue.slice(1)); 
              else if(cellValue.includes('%')) cellValue = cellValue.slice(0,-1) / 100;
              this.newArray[nIndex][key] = cellValue;
            }
            
          }
        }
      }
    }
    for(let nNewArrayIndex = 0;nNewArrayIndex < this.newArray.length;nNewArrayIndex++)
    {
      for(const [key,value] of Object.entries(this.newArray[nNewArrayIndex]))
      {
        if(value == "" || value == "Null" || value == null)
        {
          delete this.newArray[nNewArrayIndex][key];
        }
      }
    }
    this.oSelectedTableDetails;
    let schemaName = this.oSchemaName;
    let appName = this.oSelectedTableDetails.appName;
    let dsName : string;
    if(this.oSelectedTableDetails.dsName != null)
    {
      dsName = this.oSelectedTableDetails.dsName;
    }
    else
    {
      dsName = 'common';
    }
    let className = this.oSelectedTableDetails.name;
    this.oDataService.DataService_SaveEditRecords(this.sSaveFunctionName!=""?this.sSaveFunctionName:'saveAll',appName,dsName,className,schemaName,this.sSaveFunctionName!=""?{list : this.newArray}:this.newArray).subscribe({next:result =>{
    if(result.status == 'failed')
    {
      for(let i = 0;i<this.lTableAttributes.length;i++)
      {
        if(this.lTableAttributes[i].ruleId == 'percentageRule')
        {
          for(let nIndex = 0; nIndex < this.newArray.length;nIndex++)
          {
            for(const [key,value] of Object.entries(this.newArray[nIndex]))
            {

              if(`${key}` == this.lTableAttributes[i].name)
              {
                if(`${value}` != '')
                {
                  this.newArray[nIndex][key] = Math.round(JSON.parse(`${value}`) * 100) + '%';
                }
              }
            }
          }
        }
      }
      this.DataTablesComponent_ShowAlert(result.message,"danger","danger");
    }
    else
    {
      this.DataTablesComponent_ShowAlert("Records saved successfully.","success","success");
      this.sSelectedRow = "";
      let booleanData = false;
      this.newArray.forEach(element => {
        if(element.hasOwnProperty('_new_'))booleanData = true;
      });
      if(booleanData)
      {
        this.DataTablesComponent_GetTableRecords(this.nDataTableSize,1,this.sQueryString,this.oSelectedRecord,'asc')
      }
      else
      {
        this.DataTablesComponent_GetTableRecords(this.nDataTableSize,1,this.sQueryString,this.oSelectedRecord,'asc')
      }
      this.newArray=[];
    }
    },
    error:(error) =>
    {
      console.log("error ====>>>>>",error)
      this.DataTablesComponent_ShowAlert("Internal server error, please try again later.","danger","danger")
    }});
    }
  }


  DataTablesComponent_ResetDataTableAfterFiltering(nIncomingSelectedRecord)
  {
    for(let nIndex=0;nIndex<this.lTableAttributes.length;nIndex++)
    {
      if(this.lTableAttributes[nIndex].value != "")
      {
        this.lTableAttributes[nIndex].value = "";
        this.lTableAttributes[nIndex].direction = "";
      }
    }
      this.sSelectedRow = "";
      this.sQueryString="";
      this.lTableRecords = [];
      this.newArray=[];
      this.nCurrentPage = 1;
      this.bSelectMode = false;
      this.lSelectedRecordsList = [];
      this.oSelectedRow = {};
      this.DataTablesComponent_Resetheadersorting();
      this.DataTablesComponent_GetTableRecords(this.nDataTableSize,1,this.sQueryString,nIncomingSelectedRecord,'asc');
      this.editing1={};
      this.oSessionService.cSessionService_SetSortingData({});
      this.oSessionService.cSessionService_SetAttributesList(this.lTableAttributes);
  }

  DataTablesComponent_ClearLocalStorageAttributes()
  {
    localStorage.removeItem('lSortingOrder');
    localStorage.removeItem('lsTableAttributes');
  }

  DataTableComponent_ShowErrorUnsavedRecords(sIncomingChangeType)
  {
    switch (sIncomingChangeType) 
    {
      case 'Pagination':
        this.nCurrentPage = this.nPreviousPage;
        this.DataTablesComponent_ShowAlert("Please save your changes before moving to another page!","danger","danger");
        break;
      case 'Searching':
        this.DataTablesComponent_ShowAlert("Please save your changes before searching for a record!","danger","danger");
        break;
      
      case 'Sorting':
        this.DataTablesComponent_ShowAlert("Please save your changes before sorting for a record!","danger","danger");
        break;
    }
  }

  DataTableComponent_GetPageFromService(event)
  {
    let incommingPage = event;
    if(this.sQueryString !== "")
    {
      let start = ((incommingPage-1) * this.nDataTableSize) + 1;
      this.DataTablesComponent_GetTableRecords(this.nDataTableSize,start,this.sQueryString,this.oSelectedRecord,'asc');
      this.sSelectedRow = "";
      this.nSelectedRowId = "";
    }
    else
    {
        this.lTableRecords = [];
        if(incommingPage!==this.nCurrentPage)
        { 
        this.nCurrentPage=incommingPage;
        this.nPreviousPage = this.nCurrentPage;
        let start = ((incommingPage-1) * this.nDataTableSize) + 1;
        this.DataTablesComponent_Resetheadersorting();
        this.DataTablesComponent_GetTableRecords(this.nDataTableSize,start,this.sQueryString,this.oSelectedRecord,'asc');
        this.sSelectedRow = "";
        this.nSelectedRowId = "";
        }
      }
      if (this.scrollContainerRef && this.scrollContainerRef.nativeElement) {
        this.scrollContainerRef.nativeElement.scrollTop = 0;
        this.scrollContainerRef.nativeElement.scrollLeft = 0;
        }
    
  }

  DataTablesComponent_SortingColumn({column, direction}: SortEvent)
  {
    if (this.newArray.length>0) 
    {
      this.DataTablesComponent_ShowAlert("Please save your changes before moving to sorting the records!","danger","danger");
    } 
    else 
    {
      this.headers.forEach(header => {
          if (header.sortable !== column) {
            header.direction = '';
          }
        });
      if(direction !== "")
      {
        // event was triggered, start sort sequence
        this.loading = true;
        this.oSortingQuery="";

        let dsName:string;
          let fileName : string = this.oSelectedRecord.fileName;
          
          if(fileName.split('/')[2] == null)
          {
            dsName = fileName.split('/')[0];
          }
          else
          {
            dsName = "";
            let beta = fileName.split('/')
            for(let i=2;i < beta.length-1; i++)
            {
              dsName = dsName + "/" + beta[i];
            }
            dsName = dsName.substring(1);
          }
          let name = this.oSelectedRecord.name;
          if(dsName.includes('postgres') || dsName.includes('Source_MasterData') || dsName.includes('Source_MasterData_Dev'))
          {
            for(let nIndex = 0;nIndex < this.lColumnList.length; nIndex++)
            {
              if(this.lColumnList[nIndex].prop == column)
              {
                let newValue = this.lColumnList[nIndex].value;
                this.oSortingQuery = "\"" + newValue + "\" " + direction;
              }
            }
          }
          else
          {
            this.oSortingQuery = "t1." + column + " " + direction;
          }
          this.lTableAttributes[this.lTableAttributes.findIndex((tblColumn)=>{return tblColumn.prop==column})].direction = direction;
          this.lTableAttributes.forEach(element => {if(element.prop != column)element.direction = ""});
          let queryString = this.oSessionService.cSessionService_GetSortingData();
          if(queryString?.where != '')
          {
            this.sQueryString = queryString?.where;
          }
          let sortingBody = 
          {
            columnDirection : direction,
            columnName:column,
            orderBy:this.oSortingQuery,
            where:this.sQueryString
          }
          this.oSessionService.cSessionService_SetSortingData(sortingBody);
          this.oSessionService.cSessionService_SetAttributesList(this.lTableAttributes)
          let body = {};
          if(this.sQueryString != "")
            {
              body = 
              {
                "size": this.nDataTableSize,
                "start": 1,
                "orderBy" : this.oSortingQuery,
                "where" : this.sQueryString,
                "usingRowLimits": true,
              }
            }
            else
            {
              body = 
              {
                "size": this.nDataTableSize,
                "start": 1,
                "orderBy" : this.oSortingQuery,
                "usingRowLimits": true,
              }
            }
            this.oDataService.DataService_GetTableRecords(body,dsName,name,this.oSchemaName,this.oSelectedTableDetails.appName).subscribe({next:(result : any) => 
            {
              if(result.status==='failed')
              {
              console.log("DataTablesComponent_GetTableRecords : Error Response ==> ",result);
              this.lTableRecords = [];
              this.lTotalElements = 0;
              }
              else
              {
                this.lTableRecords = [];
                this.lTableRecords = result.items;
                if(this.lTableRecords)
                {
                this.lTableRecords.forEach(record=>{
                  for (const key in record) 
                  {
                    let attribIndex = this.lTableAttributes.findIndex(attribute=>{return attribute.name===key});
                    if( attribIndex!=-1)
                    {
                      if (this.lTableAttributes[attribIndex].ruleId=="percentageRule") 
                      {
                        record[key]=Math.round(JSON.parse(`${record[key]}`) * 100) + '%';
                      } 
                    }
                  }
                })
                for(let nIndex = 0; nIndex < this.lTableRecords.length;nIndex++)
                {
                  for(const [key,value] of Object.entries(this.lTableRecords[nIndex]))
                  {
                    if(`${key}`.includes('_Date'))
                    {
                      let dateString = `${value}`
                      this.lTableRecords[nIndex][key] = this.dDatepipe.transform(dateString, 'MM/dd/yyyy');
                    }
                  }
                }
                }
                setTimeout(() => { this.loading = false}, 1000);
                this.lTotalElements = result.totalItems;
                this.nCurrentPage = 1;
                this.lOriginalRows = JSON.parse(JSON.stringify(this.lTableRecords));
              }
            },
            error:(error) =>
            {
              console.log("error ====>>>>>",error)
              this.DataTablesComponent_ShowAlert("Internal server error, please try again later.","danger","danger")
            }});
      }
      else
      {
        let queryString = this.oSessionService.cSessionService_GetSortingData();
          if(queryString?.where != '')
          {
            this.sQueryString = queryString?.where;
          }
        let sortingBody = 
          {
            orderBy:"",
            where:this.sQueryString
          }
          this.oSessionService.cSessionService_SetSortingData(sortingBody);
          this.lTableAttributes[this.lTableAttributes.findIndex((tblColumn)=>{return tblColumn.prop==column})].direction = "";
          this.oSessionService.cSessionService_SetAttributesList(this.lTableAttributes)
        this.DataTablesComponent_GetTableRecords(this.nDataTableSize,1,this.sQueryString,this.oSelectedRecord,'asc');
      }
    }
  }

  DataTablesComponent_Resetheadersorting()
  {
    this.headers?.forEach(header => {
      if (header.sortable !== '' || header.sortable == '') {
        header.direction = '';
      }
    });
  }
  DataTablesComponent_DeleteRecord()
  {
    if(this.nSelectedRowId)
    {
      try
      {
        let schemaName = this.oSchemaName
        let appName = this.oSelectedTableDetails.appName;
        let dsName : string;
        if(this.oSelectedTableDetails.dsName != null)
        {
          dsName = this.oSelectedTableDetails.dsName;
        }
        else
        {
          dsName = 'common';
        }
        let className = this.oSelectedTableDetails.name;
        this.oDataService.DataService_DeleteRecord(appName,dsName,className,schemaName,this.nSelectedRowId).subscribe({next : result =>{
          if(result.status == 'failed')
          {
            console.log('DataTablesComponent_DeleteRecord ===> Response : ',result);
            this.DataTablesComponent_ShowAlert(result.message,"danger","danger");
          }
          else
          {
            console.log('DataTablesComponent_DeleteRecord ===> Response : ',result);
            this.DataTablesComponent_ShowAlert("Record deleted successfuly.","success","success");
            let nIndex = this.newArray.findIndex(element => element.ID == this.nSelectedRowId || element.id == this.nSelectedRowId)
            if(nIndex !== -1)this.newArray.splice(nIndex,1);
            let recordIndex = this.lTableRecords.findIndex(element => element.ID == this.nSelectedRowId || element.id == this.nSelectedRowId);
            if(recordIndex !== -1)this.lTableRecords.splice(recordIndex,1);
            this.lTableRecords = this.lTableRecords.filter(record => record.id !== this.nSelectedRowId || record.ID !== this.nSelectedRowId );
            this.sSelectedRow = "";
            this.nSelectedRowId = "";
          }
        },
        error : (error) =>
        {
          console.log("error ====>>>>>",error)
          this.DataTablesComponent_ShowAlert("Internal server error, please try again later.","danger","danger")
        }});
      }
      catch(error)
      {
        console.log("DataTablesComponent_DeleteRecord : Error",error);
      }
    }
  }

  DataTableComponent_SearchOnKeyUp(event) {
    if(event.keyCode != 32 && !event.target.value.includes('*'))
    {
      let input = event.target.value;
      if (input.length > 1 || input.length == 1) 
      {
        this.results = this.DataTableComponent_SearchFromArray(this.searchArray,input);
      }
      else
      {
        this.results = [];
        this.results= this.searchArray;
      }
    }
    // if (this.scrollContainerRef && this.scrollContainerRef.nativeElement) {
    //   this.scrollContainerRef.nativeElement.scrollTop = 0;
    //   this.scrollContainerRef.nativeElement.scrollLeft = 0;
    //   }
  }  
  DataTableComponent_OnKeyPress(event,nIncomingPattern,cell,nIncomingPatternMessage,rowIndex)
  {
    if(nIncomingPattern != undefined && event.keyCode != 13)
    {let term = event.target.value;
    var re = new RegExp(nIncomingPattern);
      if(term != '')
      {
        if(re.test(term)) { 
          delete this.editing1[rowIndex + '-' + cell];
          this.DataTableComponent_Resetalert();
          return true;
        }
        else
        {
          this.editing1[rowIndex + '-' + cell] = true;
          let sResMessage  = "";
          if(nIncomingPatternMessage)
          {
            sResMessage = nIncomingPatternMessage;
          }
          else
          {
            sResMessage = "Column "+ cell +" has invalid value.";
          }
          this.DataTablesComponent_ShowAlert(sResMessage,"danger","danger")
          return false;
        }
      }
      else
      {
        delete this.editing1[rowIndex + '-' + cell];
        this.DataTableComponent_Resetalert();
      }}
  }

  DataTableComponent_SearchFromArray(arr, regex) {
    let matches = [];
    for (let i = 0; i < arr.length; i++) {
        if (arr[i].match(regex)) {
          matches.push(arr[i]);
        }
    }
    this.results = [];
    return matches;
  }

  DataTableComponent_CopyAllRecordstoClipBoard()
  {
    let result=""
    this.lSelectedRecordsList =  JSON.parse(JSON.stringify(this.lTableRecords));
    this.oSelectedRow={};
    this.sSelectedRow = "";
    let headers = [];
    this.lTableAttributes.forEach(attrib => {
      if(attrib.prop != 'id' && attrib.prop != 'ID')
      {
        headers.push(attrib.prop)
      }
    });
    for (let i=0;i <headers.length; i++) 
    {
      result+=headers[i]+'\t'
    }
    result = result.substring(0, result.length - 1) + '\n'
    for(let i = 0; i<this.lSelectedRecordsList.length;i++)
    {
      for (let index = 0; index < headers.length; index++) 
      {
        result+=this.lSelectedRecordsList[i][headers[index]]==undefined?'Null'+'\t':this.lSelectedRecordsList[i][headers[index]]+'\t'
      }
      result = result.substring(0, result.length - 1)+'\n'
    }
    
    result = result.substring(0, result.length - 1)
    navigator.clipboard.writeText(result);
    this.DataTablesComponent_ShowAlert("All records copied to clipboard.","success","success");
  }
  DataTableComponent_Resetalert()
  {
    this.bResponseAlert = false;
  }
  DataTableComponent_OpenDeleteDataTableModal(oContent)
  {
    this.modalService.open(oContent , {
      size: 'md',
      centered:true,
      backdrop:'static'
    })
  
  }
  DataTablesComponent_DisplayRevertChangesPopUpModal(revertChangesPopUp,sIncommingActionType)
  {
    if(JSON.stringify(this.editing1)!=='{}' && sIncommingActionType === "delete")
    {
      this.DataTablesComponent_ShowAlert("Please fix highlighted issues before deleting records!",'danger','danger');
    }
    else
    {
      this.modalService.open(revertChangesPopUp , {
        size: 'md',
        centered:true,
        backdrop:'static'
      })
    }
  }
  DataTablesComponent_DisplayConfirmSaveRecord(confirmSavePopup)
  {
    if(this.newArray.length > 0)
    {
      this.modalService.open(confirmSavePopup , {
        size: 'md',
        centered:true,
        backdrop:'static'
      })
    } 
    else
    {
      this.DataTablesComponent_ShowAlert("No changes made.",'danger','danger');
    }
  }
  DataTablesComponent_RevertChangesModal()
  {
    this.nCurrentPage = 1;
    this.editing1={};
    this.DataTablesComponent_ClearLocalStorageAttributes();
    this.sQueryString="";
    this.DataTablesComponent_GetTableAttributes(this.oSelectedRecord);
  }
  DataTableComponent_OpenEditRowModal(incommingObject,incommingModal,nIncomingIndex)
  {
    
    this.nIncomingRwoIndexForModal = nIncomingIndex;
    this.lModalEditRows = [];
    this.editingForModel = {};
    this.editingForAutoSuggestion = {};
    for(const [key,value] of Object.entries(incommingObject)){
      if(key !== 'id' && key !== 'uid' && key !== 'ID')
      {
        this.lModalEditRows.push({KeyName : key, keyValue : value});
      }
    }
    for (let index = 0; index < this.lTableAttributes.length; index++) {
      for (let i = 0; i < this.lModalEditRows.length; i++) {
        if(this.lModalEditRows[i].KeyName === this.lTableAttributes[index].prop)
        {
          this.lModalEditRows[i] = Object.assign(this.lModalEditRows[i], this.lTableAttributes[index])
        }
      }
    }
    this.lModalEditRows.forEach(element => {
      if(element.inputType  === 'date') {
        element.keyValue = this.dDatepipe.transform(element.keyValue,'yyyy-MM-dd');
      }
    });
    this.modalService.open(incommingModal, {centered:true , size:'lg',backdrop:'static'})
  }
  DataTableComponent_OpenSettingsModal(incommingModal)
  {
    this.modalService.open(incommingModal, {centered:true, size:'lg',backdrop:'static'})
  }
  DataTableComponent_UpdateTableRowValues()
  {
    for(let index = 0; index < this.lModalEditRows.length; index++) 
    {
      for (const [key,value] of Object.entries(this.lTableRecords[this.nIncomingRwoIndexForModal])) 
      {
        if(key === this.lModalEditRows[index].prop)
        {
          this.lTableRecords[this.nIncomingRwoIndexForModal][key] = this.lModalEditRows[index].keyValue;
          break;
        }
      }
    }
    for (const key in this.lTableRecords[this.nIncomingRwoIndexForModal])
    {
      if (this.lOriginalRows[this.nIncomingRwoIndexForModal][key]!= this.lTableRecords[this.nIncomingRwoIndexForModal][key])
      {
        let index = this.newArray.indexOf(this.lTableRecords[this.nIncomingRwoIndexForModal])
        if(index == -1)
        {
          if(this.lTableRecords[this.nIncomingRwoIndexForModal].hasOwnProperty('_new_')) 
          {
            const isEmpty = Object.values(this.lTableRecords[this.nIncomingRwoIndexForModal]).every(x => x === null || x === '');
            if (!isEmpty) 
            {
              this.newArray.push(this.lTableRecords[this.nIncomingRwoIndexForModal]);
            } 
          } 
          else
          {
            this.newArray.push(this.lTableRecords[this.nIncomingRwoIndexForModal]);
          }
        }
        else
        {
          this.newArray.splice(index,1,this.lTableRecords[this.nIncomingRwoIndexForModal]);
        }
        break;
      }
      else
      {
        let index = this.newArray.indexOf(this.lTableRecords[this.nIncomingRwoIndexForModal])
        if(index!= -1)
        {
          this.newArray.splice(index,1);
        }
      }
    }
  }
  DataTableComponent_OnKeyPressForModal(event,nIncomingPattern,cell,rowIndex)
  {
    if(nIncomingPattern != undefined)
    {
    let term = event.target.value;
    var re = new RegExp(nIncomingPattern);
      if(term != '')
      {
        if(re.test(term)) { 
          delete this.editingForModel[rowIndex + '-' + cell];
          return true;
        }
        else
        {
          this.editingForModel[rowIndex + '-' + cell] = true;
          return false;
        }
      }
      else
      {
        delete this.editingForModel[rowIndex + '-' + cell];
      }}
  }
  DataTableComponent_CheckValidity()
  {
    if(JSON.stringify(this.editingForModel) !== '{}')
    {
      this.bModelUpdateButton = true;
    }
    else
    {
      this.bModelUpdateButton = false;
    }
  }
  DataTableComponent_AutoCompleteSuggestionValueForModel(cell,nIncomingIndex)
  {
    this.editingForAutoSuggestion = {};
    this.editingForAutoSuggestion[nIncomingIndex + '-' + cell] = true;
    this.results = [];
    this.searchArray = [];
    for(const [key,value] of Object.entries(this.SearchResults))
    {
      if(`${key}` == cell)
      {
        let distinctVlaueArray : any = [];
        distinctVlaueArray = [value];
        distinctVlaueArray[0].forEach(element => this.searchArray.push(element));
      }
    }
    this.results = this.searchArray;
  }
  DataTableComponent_CloseAutoCompleteSuggestionValueDropDownForModel(cell,nIncomingIndex)
  {
    setTimeout(() => {this.editingForAutoSuggestion[nIncomingIndex + '-' + cell] = false;}, 1000);
  }
  DataTablesComponent_UpdateSelectedCellValueForModel(sIncomngValue,cell,nIncomingIndex,nIncomingPattern)
  {
    let term = sIncomngValue;
    var re = new RegExp(nIncomingPattern);
    if(re.test(term)) { 
      delete this.editingForModel[nIncomingIndex + '-' + cell];
    }
    else
    {
      this.editingForModel[nIncomingIndex + '-' + cell] = true;
    }
    this.lModalEditRows[nIncomingIndex].keyValue = sIncomngValue;
    this.editingForAutoSuggestion[nIncomingIndex + '-' + cell] = false;
    this.results = [];
  }
  ngOnDestroy(): void {
    localStorage.removeItem('lsSelectedTable')
  }
  toggleView(){
    this.editMode=!this.editMode
  }

 


  DataTablesComponent_GetTableRecordDetail(incommingObject,incommingModal,nIncomingIndex)
  {
    let body = this.oSelectedRecord?.name+'/'+incommingObject.id;
    this.oDataService.DataService_GetDataManagerTableRecordDetails(body).subscribe(
      {
        next : result => 
        {
          if(result.status == 'failed')
          {
            console.log('DataTablesComponent_GetTableRecordDetail ===> Response : ',result);
            this.DataTablesComponent_ShowAlert(result.message,"danger","danger");
          }
          else
          {     
            this.createdHtml = undefined;
            if(result?.html_content || incommingObject?.html_content){
              let html =JSON?.parse(Object?.entries(result)?.length > 0 ? result?.html_content : incommingObject?.html_content)
              console.log("Prase HTML JSON",html)
              this.createdHtml = this.jsonUtil.generatePageHTML(html.htmlParas);
              console.log("Html from JSON ==>>",this.createdHtml);
            }
            this.lModalEditRows = [];
            this.lHiddenModalEditRows=[];
            for(const [key,value] of Object.entries(Object.entries(result).length > 0 ? result : incommingObject)) {
              if(key !== 'id' && key !== 'uid' && key !== 'ID') {
                const field : any = { KeyName: key, keyValue: value };
                this.lTableAttributes.forEach(attr => {
                  if(attr.prop === key) {
                    Object.assign(field, attr);
                  }
                });
                if (field.inputType === 'date') {
                  field.keyValue = this.dDatepipe.transform(field.keyValue, 'yyyy-MM-dd');
                }
                
                if (field.listHidden) {
                  this.lHiddenModalEditRows.push(field);
                } else {
                  this.lModalEditRows.push(field);
                }
              }
            }
            this.modalService.open(incommingModal, { centered: true,
              backdrop: "static",
              size: "fullscreen"})
          }
      },
      error : (error) =>
      {
        console.log("error ====>>>>>",error)
        this.DataTablesComponent_ShowAlert("Internal server error, please try again later.","danger","danger")
      }});
  }
  
}